import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconChevronRight(props: IconProps) {
	return (
		<Icon {...props}>
			<path
				fill="currentColor"
				d="M9.3 2.45a.8.8 0 0 0-.57-.23H6.2a.82.82 0 0 0-.58 1.4L8.13 6.1l5.23 5.33c.24.27.17.96 0 1.16l-5.2 5.31-2.52 2.49a.82.82 0 0 0 .57 1.4H8.8q.33-.02.58-.24l9.01-8.96a.8.8 0 0 0 0-1.16z"
			/>
		</Icon>
	);
}
